import { useEffect, useRef, useState } from "react";

export default function SuccessScreen({
    flowData,
    updateFlowData,
    flowContext,
    updateFlowContext,
    next,
    back,
    loading,
    setLoading,
    error,
    setError,
}) {

    const pollTimerRef = useRef(null);
    const pollingRef = useRef(false);

    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const formattedCurrentTime = currentTime.toLocaleTimeString(
        "en-IN",
        {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        }
    );


    /*
     * ---------------------------------------------------------
     * Success data comes entirely from backend
     * ---------------------------------------------------------
     */

    const waiverSuccess =
        flowData?.waiverSuccess;   

    const signedPdf =
        flowData?.tmpResponseVars?.signedPdf;

    const serviceName =
        waiverSuccess?.serviceName ||
        flowData?.selectedService?.name ||
        flowContext?.service?.serviceName ||
        flowContext?.service?.name ||
        "";

    const businessName =
        waiverSuccess?.businessName || "";


    const clientName =
        waiverSuccess?.clientName || "";

    /* const approvalTime =
        waiverSuccess?.approvalTime
            ? new Date(
                waiverSuccess.approvalTime
            ).toLocaleTimeString()
            : ""; */
    const approvalTime =
        waiverSuccess?.approvalTime
            ? new Date(
                waiverSuccess.approvalTime
            ).toLocaleString("en-IN", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "numeric",
                minute: "2-digit",
                hour12: true
            })
            : "";

    const guardianApproved =
        waiverSuccess?.guardianApproved === true;


    /*
     * ---------------------------------------------------------
     * Poll every 5 minutes
     * ---------------------------------------------------------
     */

    useEffect(() => {

        const pollSuccess = async () => {

            if (pollingRef.current) return;

            pollingRef.current = true;

            try {

                const response =
                    await next({
                        action: "poll_success"
                    });

                const refreshedWaiverSuccess = response?.flowData?.waiverSuccess;

                if (refreshedWaiverSuccess?.approvalValid === false) {

                    clearInterval(
                        pollTimerRef.current
                    );

                    return;
                }

                if (refreshedWaiverSuccess) {
                    updateFlowData({
                        waiverSuccess: refreshedWaiverSuccess,

                        ...(response?.flowData?.tmpResponseVars?.signedPdf
                            ? {
                                tmpResponseVars: {
                                    ...(flowData?.tmpResponseVars || {}),
                                    signedPdf:
                                        response.flowData.tmpResponseVars.signedPdf
                                }
                            }
                            : {})
                    });
                }

            } catch (err) {

                console.error(
                    "Success screen polling failed:",
                    err
                );

            } finally {

                pollingRef.current = false;
            }
        };


        pollTimerRef.current =
            setInterval(
                pollSuccess,
                5 * 60 * 1000
            );  //poll every 5 minutes


        return () => {

            if (pollTimerRef.current) {

                clearInterval(
                    pollTimerRef.current
                );
            }
        };

    }, [next, updateFlowData]);


    const done = () => {

        if (loading) return;

        setError("");

        next({
            action: "waiver_done",
        });
    };


    return (
       <div className={`page ${loading ? "page-loading" : ""}`}>
            
            {loading && (
                <div className="loading-overlay">
                    Loading...
                </div>
            )}

            {error && (
                <div className="text-red-600 mt-2">
                    {error}
                </div>
            )}          

            <div className="page-content success-page">

                <div className="success-logo">
                    📝
                </div>


                <div className="success-header">

                    <div className="success-header-title">
                        Ready for check-ina
                    </div>

                    <div className="success-header-subtitle">
                        Show this screen to staff.
                    </div>

                </div>


                
                <div className="success-checkmark">
                    <svg
                        className="check-icon"
                        viewBox="0 0 100 100"
                        role="img"
                        aria-label="Approved"
                    >
                        <circle
                            className="circle-spin"
                            cx="50"
                            cy="50"
                            r="50"
                            fill="#017e5e"
                        />

                        <path
                            className="check-path"
                            d="M27 53 L40 66 L73 33"
                        />
                    </svg>
                </div>



                <div className="success-status">
                    APPROVED
                </div>

                <div className="success-current-time">
                    <div className="success-current-time-label">
                        Current time:
                    </div>

                    <div className="success-current-time-value">
                        {formattedCurrentTime}
                    </div>

                    <div className="success-current-time-note">
                        (updates every second)
                    </div>
                </div>


                {signedPdf?.viewUrl && (
                    <button
                        type="button"
                        className="primary-button"
                        onClick={() => {
                            window.open(
                                signedPdf.viewUrl,
                                "_blank",
                                "noopener,noreferrer"
                            );
                        }}
                    >
                        TEMP Link: Click here to View/Download the Signed Waiver
                    </button>
                )}


                <div className="success-substatus">
                    {guardianApproved
                        ? "Guardian co-signed"
                        : "Waiver signed"}
                </div>


                <div className="success-divider"></div>


                <div className="success-service">
                    {serviceName} at  {businessName} 
                </div>

                <div className="success-client">
                    {clientName} 
                </div>


                <div className="success-divider"></div>


                <div className="success-time">
                    ◌ Approved at: {approvalTime}
                </div>

                {/*waiverSuccess?.flowId && (
                    <div className="success-qr">
                        <div className="success-qr-placeholder">
                            QR
                        </div>

                        <div className="success-flow-id">
                            {waiverSuccess.flowId}
                        </div>
                    </div>
                )*/}

            </div>


            <div className="page-footer">

                <button
                    className="primary-button"
                    onClick={done}
                >
                    Done
                </button>

            </div>

        </div>
    );
}